var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrderCartAudit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M14.5 20.4c-1.2 0-2.2-.8-2.5-2L8.7 4.1c0-.1-.2-.2-.3-.2l-3.6.9c-.3.1-.5-.1-.6-.3-.1-.3.1-.6.4-.6L8.1 3c.7-.2 1.4.2 1.5.9l3.3 14.3c.2.8 1 1.3 1.9 1.2l6.4-1.3c.3-.1.5.1.6.4s-.1.5-.4.6L15 20.3c-.1.1-.3.1-.5.1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA600",
  d: "m14.2 18.7-.3-.1c-.1-.1-.2-.2-.3-.4l-1.1-5.5.1-.3c.1-.1.2-.2.4-.3l5.3-1.1c.3-.1.7.1.7.5l1.1 5.5-.1.3c-.1.1-.2.2-.4.3zm-.5-5.6.9 4.5 4.5-.9-.9-4.5zM12.8 11.6c-.3 0-.5-.2-.6-.5l-.7-3.5.1-.3c.1-.1.2-.2.4-.3l3.3-.7c.3-.1.7.1.7.5l.7 3.5-.1.3c-.1.1-.2.2-.4.3l-3.3.7zM12.6 8l.5 2.6 2.6-.5-.5-2.6zm3.1 2.4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M14.1 23.1c-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7c1 0 1.7.8 1.7 1.7s-.8 1.7-1.7 1.7m0-2.5c-.4 0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M16 16.7c-.1 0-.2 0-.3-.1l-.8-.5c-.2-.1-.3-.4-.2-.7.1-.2.4-.3.7-.2l.4.3 1.3-2c.2-.2.5-.3.7-.1s.3.5.1.7l-1.6 2.4c0 .1-.2.2-.3.2"
})));
export default SvgOrderCartAudit;